import * as React from 'react';
import { FunctionComponent, useEffect, useMemo, useState } from 'react';
import { format } from 'date-fns';
import Api from '../../api/API';
import { useNavigate } from 'react-router-dom';
import './SurveyStyles.scss';
import { HOME_ROUTE } from '../../utils/consts';
import { notification, NotificationType, StepsSurvey, SurveyStepType, ConvertedPayload } from '@iba-team/portal-react-components/dist';

export const SurveyPage: FunctionComponent = () => {
  const navigate = useNavigate();
  const [endDate, setEndDate] = useState('');
  const testMock: SurveyStepType =
    {
      1: [
        {
          type: 'checkbox',
          checkboxElements: ['Employee (Сотрудник)',
            'Project Manager / Team Lead',
            'Delivery Manager',
            'Division Head (Руководитель отдела или сектора)',
            'Division Director (Директор отделения)',
            'Department Director',
            'Division economist',
            'HR specialist',
            'Other'
          ],
          label: 'Your role in IBA Group',
          required: true,
          name: 'ROLE'
        }
      ],
      2: [
        {
          type: 'grade',
          label: 'How satisfied are you with the speed of the Leave Management?',
          name: 'LM_SPEED_SATISFACTION',
          required: true,
          gradeElements: ['Totally satisfied', 'Satisfied' , 'Neutral', 'Unsatisfied', 'Totally unsatisfied'],
          direction: 'column',
        },
        {
          type: 'description',
          label: 'Please comment your score (можно на русском языке)',
          name: 'LM_SPEED_SATISFACTION_SCORE_COMMENT',
          required: false,
          placeholder: 'Your answer',
        },
      ],
      3: [
        {
          type: 'grade',
          label: 'How satisfied are you with the support service?',
          name: 'SUPPORT_SATISFACTION',
          required: true,
          gradeElements: ['Totally satisfied', 'Satisfied' , 'Neutral', 'Unsatisfied', 'Totally unsatisfied'],
          direction: 'column'
        },
        {
          type: 'description',
          label: 'Please comment your score (можно на русском языке)',
          name: 'SUPPORT_SATISFACTION_SCORE_COMMENT',
          required: false,
          placeholder: 'Your answer',
        },
      ],
      4: [
        {
          type: 'grade',
          label: 'How satisfied are you with your absence management?',
          name: 'ABSENCE_SATISFACTION',
          required: true,
          gradeElements: ['Totally satisfied', 'Satisfied' , 'Neutral', 'Unsatisfied', 'Totally unsatisfied'],
          direction: 'column'
        },
        {
          type: 'description',
          label: 'Please comment your score (можно на русском языке)',
          name: 'ABSENCE_MANAGEMENT_SATISFACTION_SCORE_COMMENT',
          required: false,
          placeholder: 'Your answer',
        },
      ],
      5: [
        {
          type: 'grade',
          label: 'How satisfied are you with working with the absences of other employees?',
          name: 'OTHER_EMPLOYEES_SATISFACTION',
          required: true,
          gradeElements: ['Totally satisfied', 'Satisfied' , 'Neutral', 'Unsatisfied', 'Totally unsatisfied'],
          direction: 'column'
        },
        {
          type: 'description',
          label: 'Please comment your score (можно на русском языке)',
          name: 'OTHER_EMPLOYEES_ABSENCE_MANAGEMENT_SATISFACTION_SCORE_COMMENT',
          required: false,
          placeholder: 'Your answer',
        },
      ],
      6: [
        {
          type: 'description',
          label: 'Tell us more about your experience of using Leave Management (можно на русском языке).',
          name: 'LM_EXPERIENCE',
          placeholder: 'Your answer',
          required: false
        }
      ]
    };


  const surveyHeader = () => {
    return(
      <div className={'survey_header__container'}>
        <div className={'survey_header__container__h'}>Satisfaction Survey</div>
        <div className={'survey_header__container__subH'}>
          Dear User !
          <br/>
          <br/>
          We are constantly working on improvement of the Leave Management service to make your work more comfortable. Your opinion is very important to us to make the service even better.
          We will be grateful if you complete this questionnaire.</div>
        {endDate && <div className={'survey_header__container__endate'}>Answers are accepted until  {format(new Date(endDate), 'dd MMMM')}</div>}
      </div>
    );
  };

  useEffect(()=> {
    Api<null, {endDate: string}>().get(`${process.env.REACT_APP_LM_API_URL}/api/survey/v1/current-survey-info`).then(res => {
      setEndDate(res.endDate);
    });
  },[]);

  const pagesTitles = useMemo(() => {
    return [undefined, 'Evaluation of the speed of the Leave Management',
      'Evaluation of the support service performance',
      'Evaluation of work with Your absences',
      'Evaluation of work with the other employees absences ',
      'Would you like to share more information?'];
  },[]);
  const callback = (_: SurveyStepType , converted : ConvertedPayload) => {
    let index = 0;
    const questions: Record<string, string> = {};
    for(const key in converted){
      index++;
      const item = converted[key];
      questions[item.label + index] = item.value as unknown as string;
    }

    Api<null , {surveyId: string}>().get(`${process.env.REACT_APP_LM_API_URL}/api/survey/v2/current-survey-id`).then(res => {
      Api<{surveyId: string, questions: Record<string, string> }, null>().post(`${process.env.REACT_APP_LM_API_URL}/api/survey/v1/user-survey-result`, {
        surveyId: res.surveyId,
        questions: questions
      }).then(() => {
        notification.open({
          type: NotificationType.SUCCESS,
          title: 'Success',
          description: 'Thank You! Your answer has been accepted.'
        });
        setTimeout(()=> {
          navigate(HOME_ROUTE);
        },2000);
      }).catch((e) => {
        notification.open({
          title: 'Error',
          type: NotificationType.ERROR,
          description: 'Something went wrong. Please try again later.'
        });
      });
    });
  };

  return (
    <div className={'survey_page_wrapper'}>
      <StepsSurvey submitCallback={callback} renderHeader={surveyHeader()} withSteps={true} data={testMock} pagesTitles={pagesTitles}/>
    </div>
  );
};
